import momentGenerateConfig from 'rc-picker/lib/generate/moment';
import generatePicker from './generatePicker';
const DatePicker = generatePicker(momentGenerateConfig);
export default DatePicker;
